import { combineReducers } from 'redux'

import auth from './auth'
import user from './user'
import table from './table'
import log from './log'
import loader from './loader'

export default combineReducers({ auth, user, table, log, loader })
